import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "./useAuth";
import { BROKER_DESK, getBrokerDesk, setBrokerDesk } from "../api/brokerDesk";

export function useBrokerDesk() {
  const { session } = useAuth();
  const { pathname } = useLocation();
  const [params, setParams] = useSearchParams();
  const onBroker = pathname.startsWith("/broker");
  const active = onBroker && (session?.role === "broker" || session?.role === "admin");
  const [mode, setModeState] = useState(() => params.get("desk") || getBrokerDesk());

  useEffect(() => {
    function sync() {
      setModeState(getBrokerDesk());
    }
    window.addEventListener("dh-broker-desk", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("dh-broker-desk", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  useEffect(() => {
    const fromUrl = params.get("desk");
    if (fromUrl === BROKER_DESK.mine || fromUrl === BROKER_DESK.office) {
      setModeState(fromUrl);
    }
  }, [params]);

  function setMode(next) {
    const saved = setBrokerDesk(next);
    setModeState(saved);
    const nextParams = new URLSearchParams(params);
    nextParams.set("desk", saved);
    setParams(nextParams, { replace: true });
  }

  return {
    active,
    mode: active ? mode : BROKER_DESK.office,
    setMode,
    isMine: active && mode === BROKER_DESK.mine,
  };
}
